'use client';

import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import GlobalService from '@/api/services/GlobalService';
import Input from '@/components/core/Input';
import { validateForm } from '@/components/popups/MeetingBook/validationFunction';
import Toaster from '@/components/popups/Toaster';
import { MetaProviderProps, useMetaCheck } from '@/context/MetaChck';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

export const SendMessage = async (data: any, type: 'team' | 'contact' | 'event' | 'subscribe') => {
  return await GlobalService.post('/api/contact-us', {
    ...data,
    type,
  });
};

interface IFormData {
  name_surname: string;
  email: string;
  phone: string;
  message: string;
  sourceData: MetaProviderProps | null;
}
const ContactUsForm: FC = () => {
  const { metaData } = useMetaCheck();

  const [formData, setFormData] = useState<IFormData>({
    name_surname: '',
    email: '',
    phone: '',
    message: '',
    sourceData: null,
  });

  const [errors, setErrors] = useState({
    name_surname: '',
    email: '',
    phone: '',
    message: '',
  });

  const { t } = useTranslation();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setErrors((prev) => ({ ...prev, [event.target.name]: '' }));
    setFormData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const onSubmit = async () => {
    const validation = validateForm(formData);

    if (Object.values(validation).filter(Boolean).length) {
      return setErrors(validation);
    }
    return await SendMessage(formData, 'contact').then(() => {
      setFormData({ name_surname: '', email: '', phone: '', message: '', sourceData: null });
      toast(<Toaster type="success" description="Messagesent-Text" />, {
        duration: 3000,
      });
      window.dataLayer?.push?.({
        event: 'form_submission',
        form_class: 'contact_us',
        form_id: 'contact',
        ...(formData.sourceData ? { event_page: formData.sourceData.utm_source } : {}),
      });
      // removeData();
    });
  };

  useEffect(() => {
    setFormData({ ...formData, sourceData: metaData });
  }, [metaData])


  return (
    <div className="ContactUsBlock">
      <div className="ContactUsHeaderDate">
        <h1 className="ContactUsHeader">{t('Contatcus-Form-Title')}</h1>
        <p className="ContactUsDesc">{t('Contactus-Form-Paragraph')}</p>
      </div>

      <div className="contactUsInputWrp">
        <Input
          name="name_surname"
          onChange={handleChange}
          placeholder={t('Contactus-Form-Name')}
          className="popOkInput hasBg"
          value={formData.name_surname}
        />
        {errors.name_surname && <p className="error-message white-error">{errors.name_surname}</p>}
        <Input
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder={t('Contactus-Form-Email')}
          className="popOkInput hasBg"
        />
        {errors.email && <p className="error-message white-error">{errors.email}</p>}
        <Input
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder={t('Contactus-Form-Phonenumber')}
          className="popOkInput hasBg"
        />
        {errors.phone && <p className="error-message white-error">{errors.phone}</p>}
        <textarea
          name="message"
          value={formData.message}
          placeholder={t('Contactus-Form-Message')}
          className="popOkTextarea type1"
          onChange={(event) => handleChange(event as any)}
        />
        {errors.message && <p className="error-message white-error ">{errors.message}</p>}
      </div>
      <div className="contactUsBtnBlock">
        <div className="contactUsBtnBlockInner">
          <button
            onClick={onSubmit}
            className="button btnTypeBig btnTypeOrange fullWidth"
            id="contact-us-send"
          >
            <p>{t('Contactus-Form-Button-Send')}</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsForm;
